module.exports = __webpack_public_path__ + "static/img/tradeideas1.3f5a5c2.png";


//////////////////
// WEBPACK FOOTER
// ./static/fxView/images/tradeideas1.png
// module id = +cBR
// module chunks = 1